export type ShoulderCheckType = 'left' | 'right' | null;

export class ShoulderCheckController {
  public activeCheck: ShoulderCheckType = null;
  public lookAngleY: number = 0; // In radians
  public lookPitchX: number = 0;
  public checkDurationSeconds: number = 0;

  // German driving test standard: looking ~100-115 degrees back over shoulder
  private targetAngleY: number = 0;
  private targetPitchX: number = 0;

  public setCheck(type: ShoulderCheckType) {
    this.activeCheck = type;
    if (type === 'left') {
      this.targetAngleY = Math.PI * 0.62; // ~112 degrees left
      this.targetPitchX = -0.05;
    } else if (type === 'right') {
      this.targetAngleY = -Math.PI * 0.62; // ~112 degrees right
      this.targetPitchX = -0.05;
    } else {
      this.targetAngleY = 0;
      this.targetPitchX = 0;
    }
  }

  public update(deltaTime: number) {
    if (this.activeCheck !== null) {
      this.checkDurationSeconds += deltaTime;
    } else {
      this.checkDurationSeconds = 0;
    }

    // Smooth head turning interpolation (fast head turn ~0.15s)
    const turnSpeed = 16;
    this.lookAngleY += (this.targetAngleY - this.lookAngleY) * Math.min(1.0, deltaTime * turnSpeed);
    this.lookPitchX += (this.targetPitchX - this.lookPitchX) * Math.min(1.0, deltaTime * turnSpeed);
  }

  public hasValidCheck(type: 'left' | 'right'): boolean {
    return this.activeCheck === type && Math.abs(this.lookAngleY) > Math.PI * 0.45;
  }
}
